import React from 'react'
import { useState } from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  Button,
  Container,
  VStack,
  Input,
  Textarea,
  Select,
  useDisclosure
} from '@chakra-ui/react';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon
} from '@chakra-ui/accordion';

import Navbar from './Navbar'
import Footer from './Footer'


function App() {
  
  const [formData, setFormData] = useState({
    issueType: '',
    subject: '',
    message: ''
  });

  // Basic form handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Basic submit handler
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Support request received!');
    setFormData({ issueType: '', subject: '', message: '' });
  };

  const faqs = [
    {
      question: "First Question?",
      answer: "Not FAQs right now. Be one of the first!"
    },
  ]

  return (
    <Box minHeight="100vh" display="flex" flexDirection="column">
      {/* Navbar */}
      <Navbar/>

      <Box flex="1" width="100%" py={10} bg="#F8FAFC">
        <Container maxW="container.lg">
          {/* FAQ Section */}
          <Box id="faq" mb={20}>
            <Heading as="h2" size="xl" mb={8} textAlign="center">Frequently Asked Questions</Heading>
            <Accordion allowToggle>
              {faqs.map((faq, index) => (
                <AccordionItem key={index} border="1px solid" borderColor="gray.200" mb={4} borderRadius="md">
                  <AccordionButton _expanded={{ bg: 'blue.50' }} p={4}>
                    <Box flex="1" textAlign="left">
                      <Text fontWeight="semibold">{faq.question}</Text>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel pb={4} bg="white">
                    {faq.answer}
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </Box>

          </Container>
        </Box>
        <Footer/>
    </Box>
  )
}

export default App